import { getProspectsTourSteps } from "./tours/prospectsTour";
import { getMarketingListTourSteps } from "./tours/marketingListTour";
import { getDashboardTourSteps } from "./tours/dashboardTour";
import { getCampaignsTourSteps } from "./tours/campaignsTour";

// Maps tour key (as returned by the API's `key` field) to a steps getter function.
// The getter receives `navigate` so individual steps can programmatically navigate.
// Add new tours here as they are built.
export const TOUR_REGISTRY = {
  prospects: getProspectsTourSteps,
  marketing_list: getMarketingListTourSteps,
  campaigns: getCampaignsTourSteps,
  dashboard: getDashboardTourSteps,
};
